import React from 'react';
import Light from './Light'
import './LightDiagram.scss';

class LightDiagram extends React.Component {

  constructor(props){
    super(props);
    this.state = {
      lights: props.lights
    }
  }

  render() {

    const lights = this.props.lights.map((l, ix) => {
      if(l.value === 'unavailable') { return null }
      return (<Light name={l.name} state={l.value} />)
    })
    const lightsB = this.props.lights.map((l, ix) => {
      if(l.value === 'unavailable') { return null }
      if(l.name === 'F1') { return null }
      return (<Light name={`${l.name}b`} state={l.value} />)
    })
    return (
      <div className="LightDiagram">
        {lights}
      </div>
    );
  }
}


export default LightDiagram;
